import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import './index.scss'

export default function Accordion (props) {
  const {
    toggleShow, show, title, className,
  } = props

  return (
    <div className={classNames('accordion accordion__header', className)} onClick={toggleShow}>
      <span className="accordion__title">{title}</span>
      <span className={classNames('accordion__arrow', {
        'arrow-up': show,
        'arrow-down': !show,
      })} />
    </div>
  )
}

Accordion.propTypes = {
  toggleShow: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
}
